import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Chepestcabserviceinmumbai() {



  const cardData = {
    keyword: " Cheapest Cab Service in Mumbai ",


"headingDescription": "Royal Route Cab offers one of the cheapest cab services in Mumbai, providing budget-friendly, safe, and comfortable travel solutions for local rides, airport transfers, and outstation journeys. Whether you are a daily commuter, student, tourist, or business traveler, our affordable pricing ensures you get the best value for money without compromising on quality. We focus on transparent billing, no hidden charges, and economical per km rates suitable for every budget. Our professional drivers, clean vehicles, and punctual service make every ride smooth and stress-free. Our fleet includes hatchbacks, sedans, SUVs, Innova, Ertiga, and Tempo Travellers, giving customers flexible options based on budget and group size. With 24/7 availability and easy booking, Royal Route Cab is a trusted choice for cheapest cab service in Mumbai.",

"topPlaces": [
  {
    "title": "Cheapest Cab Service in Mumbai",
    "description": "Cheapest cab service in Mumbai offers affordable and reliable transportation for daily travel, airport transfers, and short city rides. It is ideal for budget-conscious passengers who want comfort and convenience at low fares."
  },
  {
    "title": "Budget Cab Service Mumbai",
    "description": "Budget cab service in Mumbai provides cost-effective travel solutions for office commutes, shopping trips, and local travel while ensuring safety and basic comfort for passengers."
  },
  {
    "title": "Low Cost Cab Service Mumbai",
    "description": "Low cost cab service in Mumbai is designed for passengers looking for economical transportation options without compromising on timely pickup and reliable service."
  },
  {
    "title": "Affordable Taxi Service Mumbai",
    "description": "Affordable taxi service in Mumbai is widely used for daily commuting, offering competitive pricing and convenient booking for short and long-distance travel."
  },
  {
    "title": "Economy Cab Service Mumbai",
    "description": "Economy cab service in Mumbai provides simple and budget-friendly vehicles suitable for individual travelers, students, and regular commuters."
  },
  {
    "title": "Cheap Airport Cab Mumbai",
    "description": "Cheap airport cab service in Mumbai offers affordable pickup and drop services for domestic and international travelers without compromising punctuality and comfort."
  },
  {
    "title": "Local Cheap Cab Service Mumbai",
    "description": "Local cheap cab service in Mumbai is perfect for short-distance travel within the city, including office trips, errands, and daily commuting at low fares."
  },
  {
    "title": "Outstation Budget Cab Mumbai",
    "description": "Outstation budget cab service from Mumbai provides economical travel options for nearby destinations like Pune, Lonavala, and Nashik with comfortable rides."
  },
  {
    "title": "Shared Cab Service Mumbai",
    "description": "Shared cab service in Mumbai is a cost-saving travel option where passengers can share rides, reducing overall travel expenses while maintaining convenience."
  },
  {
    "title": "Economical One Way Cab Mumbai",
    "description": "Economical one way cab service in Mumbai is ideal for single-direction travel, offering low-cost transportation for airport transfers and intercity trips."
  }
],






services: [
  {
    name: "Cheapest Cab Service in Mumbai",
    description: "Cheapest cab service in Mumbai offers budget-friendly travel for local, airport, and outstation journeys. Ideal for daily commuters and cost-conscious travelers, this service ensures affordable pricing with no hidden charges. Clean vehicles and professional drivers enhance comfort. It guarantees economical and reliable travel."
  },
  {
    name: "Cheapest Taxi Service in Mumbai",
    description: "Cheapest taxi service in Mumbai provides low-cost travel options with flexible booking. This service is ideal for individuals and families looking for affordable rides. Comfortable vehicles ensure a smooth journey. It guarantees value for money."
  },
  {
    name: "Cheapest Cab from Mumbai to Nashik",
    description: "Cheapest cab from Mumbai to Nashik offers affordable intercity travel without compromising safety and comfort. Ideal for business trips and family travel. Transparent pricing ensures no hidden charges. It ensures cost-effective travel."
  },
  {
    name: "Cheapest Cab in Mumbai",
    description: "Cheapest cab in Mumbai provides economical travel options for all types of journeys. This service is ideal for local travel and short trips. Easy availability ensures convenience. It guarantees budget-friendly rides."
  },
  {
    name: "Cheap Taxi in Mumbai",
    description: "Cheap taxi in Mumbai offers low-cost transportation for city travel and airport transfers. This service ensures comfort with well-maintained vehicles. Professional drivers enhance safety. It guarantees affordable travel."
  },
  {
    name: "Cheap Cabs Mumbai",
    description: "Cheap cabs Mumbai provide affordable ride options for daily commuting and occasional travel. Flexible booking and transparent pricing enhance convenience. It ensures reliable and economical journeys."
  },
  {
    name: "Cheap Taxi Mumbai",
    description: "Cheap taxi Mumbai offers budget-friendly travel solutions for individuals and groups. This service ensures comfortable rides with trained drivers. Ideal for city and airport travel. It guarantees a smooth journey."
  },
  {
    name: "Cheapest Cab from Pune to Mumbai Airport",
    description: "Cheapest cab from Pune to Mumbai airport provides affordable long-distance travel with timely pickup and drop. Ideal for flight travelers. Comfortable vehicles enhance convenience. It guarantees economical travel."
  },
  {
    name: "Cheapest Outstation Cabs from Mumbai",
    description: "Cheapest outstation cabs from Mumbai offer budget-friendly travel for intercity journeys. Ideal for family trips, business travel, and tours. Transparent pricing ensures no hidden charges. It ensures affordable long-distance travel."
  },
  {
    name: "Cheapest Cab Service in Mumbai Near Me",
    description: "Cheapest cab service in Mumbai near me helps users find nearby budget cabs quickly. Ideal for urgent travel needs. Fast booking ensures availability. It guarantees convenience and affordability."
  },
  {
    name: "Best Cheap Cab Service in Mumbai",
    description: "Best cheap cab service in Mumbai combines affordability with quality service. Professional drivers and clean vehicles ensure comfort. This service focuses on reliability and cost-effectiveness. It guarantees a great travel experience."
  },
  {
    name: "Cheapest Taxi Mumbai Contact Number",
    description: "Cheapest taxi Mumbai contact number helps customers connect directly with affordable cab providers. Quick booking and easy communication enhance convenience. It ensures hassle-free travel arrangements."
  },
  {
    name: "Book Cheapest Cab in Mumbai Online",
    description: "Book cheapest cab in Mumbai online with quick and easy booking options. Customers can select vehicle type and timing as per convenience. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Cheapest Cab Mumbai to Pune",
    description: "Cheapest cab Mumbai to Pune offers affordable intercity travel via expressway routes. Ideal for daily commuters and long-distance travelers. Comfortable vehicles ensure smooth rides. It guarantees cost-effective travel."
  }
],

tableData: [
  ["Cheapest Cab Service in Mumbai", "Cheapest Taxi Service in Mumbai"],
  ["Cheapest Cab from Mumbai to Nashik", "Cheapest Cab in Mumbai"],
  ["Cheap Taxi in Mumbai", "Cheap Cabs Mumbai"],
  ["Cheap Taxi Mumbai", "Cheapest Cab from Pune to Mumbai Airport"],
  ["Cheapest Outstation Cabs from Mumbai", "Cheapest Cab Service in Mumbai Near Me"],
  ["Best Cheap Cab Service in Mumbai", "Cheapest Taxi Mumbai Contact Number"],
  ["Book Cheapest Cab in Mumbai Online", "Cheapest Cab Mumbai to Pune"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Cheapest Cab Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly cab service in Mumbai with low per km rates, making it ideal for daily travel and short-distance rides."
  },
  {
    WhyChooseheading: "Lowest Per KM Pricing Options",
    WhyChoosedescription: "Cab fares in Mumbai start from as low as ₹9/km for sedan and ₹13/km for SUVs depending on service type and availability." 
  },
  {
    WhyChooseheading: "Best for Local & Outstation Travel",
    WhyChoosedescription: "Whether you need local rides or outstation trips, our cheapest cab service ensures maximum savings without compromising comfort."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear fare details upfront with no hidden costs, ensuring complete transparency." 
  },
  {
    WhyChooseheading: "24/7 Budget Cab Availability",
    WhyChoosedescription: "Our Mumbai cab service operates round the clock, providing affordable travel options anytime." 
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Even at low fares, all vehicles are well-maintained, air-conditioned, and sanitized regularly for a comfortable ride." 
  },
  {
    WhyChooseheading: "Multiple Low-Cost Vehicle Options",
    WhyChoosedescription: "Choose from budget hatchbacks, sedan cars, and shared ride options to reduce travel costs further." 
  },
  {
    WhyChooseheading: "Trusted Cheap Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for cheapest cab booking in Mumbai with reliable service and fair pricing." 
  }
]

};

const faqData = [
  { question: "Which is the cheapest cab service in Mumbai?", answer: "Cheapest cab services in Mumbai start from around ₹9 per km for sedan and ₹13 per km for SUVs depending on provider." },
  { question: "What is the minimum cab fare in Mumbai?", answer: "Local cab packages start from ₹250 for 1 hour (10 km) and increase based on time and distance." },
  { question: "How can I book cheap cab in Mumbai?", answer: "You can book online using cab apps or direct service providers to get best deals and discounts." },
  { question: "Is cab service available 24 hours?", answer: "Yes, most cab services in Mumbai operate 24/7." },
  { question: "What is cheapest option for daily travel?", answer: "Hatchback or shared cabs are the cheapest option for daily commuting in Mumbai." },
  { question: "Do cheap cabs include AC?", answer: "Yes, most budget cabs are AC, but pricing may vary based on vehicle type." },
  { question: "Are online cabs cheaper than local taxis?", answer: "Yes, online booking platforms often provide discounts and cheaper rates than traditional taxis." },
  { question: "What is outstation cab fare from Mumbai?", answer: "Outstation fares start from ₹10 to ₹16 per km depending on car type." },
  { question: "Do cheap cab services provide airport pickup?", answer: "Yes, affordable cab services are available for Mumbai airport pickup and drop." },
  { question: "Are vehicles safe and sanitized?", answer: "Yes, most cab providers ensure regular cleaning and safety standards." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Jadhav",
    feedback: "Cheapest cab service in Mumbai with Royal Route Cabs still felt reliable and comfortable. The ride was smooth and the service quality was maintained well.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Good budget-friendly cab service in Mumbai. The pricing was affordable and the overall journey was safe, clean, and well-managed.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/cheapest-cab-service-mumbai.jpg", // replace if needed
  "description": "Book the cheapest cab service in Mumbai with Royal Route Cabs for affordable local and outstation travel. Enjoy safe, reliable, and budget-friendly taxi service across Mumbai, Pune, Nashik, airport transfers, and more with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8/km", // indicative lowest pricing (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/cheapest-cab-service-in-mumbai"
  }
};





  return (
    <div>

<Helmet>
  <title>Cheapest Cab Service in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book cheapest cab service in Mumbai with Royal Route Cabs. Affordable local and outstation taxi service to Pune, Nashik, airport transfers and more with 24x7 availability."
  />

  <meta
    name="keywords"
    content="cheapest cab service in mumbai, cheapest taxi service in mumbai, cheapest cab from mumbai to nasik, cheapest cab in mumbai, cheap taxi in mumbai, cheap cabs mumbai, cheap taxi mumbai, cheapest cab from pune to mumbai airport, cheapest outstation cabs from mumbai, cheapest cab service in mumbai near me, best cheap cab service in mumbai, cheapest taxi mumbai contact number, book cheapest cab in mumbai online, cheapest cab mumbai to pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Chepestcabserviceinmumbai;